/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InstalledAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function InstalledAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/InstalledAction"
  
}) {
let tabSelectedAppsFilterValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.apps_filter',
})
let constantData = 'installed'
let aggregateData = fromAggregate.equals(tabSelectedAppsFilterValueData, constantData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Installed"
 onClick={onClick}
 data="tab.selected.apps_filter"
 data="'installed'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 size="normal"
 color={dtColorsNeutral900}
/>
{children}
</React.Fragment>)
}